export default __webpack_public_path__ + "static/media/07.5cb87bbd.png";